import _styled from "styled-components";
type Props = {
  children: React.ReactNode;
};
export function DeepDiveGalleryCursorButton(props: Props & React.ComponentPropsWithoutRef<"button">) {
  const {
    children,
    ...rest
  } = props;
  return <_StyledButton {...rest} $_css={[{
    "display": "inline-flex",
    "alignItems": "center",
    "justifyContent": "center",
    "columnGap": "1.4rem",
    "padding": "1.6rem"
  }, {
    "fontSize": "1.4rem",
    "lineHeight": "1",
    "letterSpacing": "0.028000000000000004rem",
    "fontWeight": "400",
    "textTransform": "uppercase"
  }, {
    "borderRadius": "8px",
    "backgroundColor": "rgba(255, 255, 255, 0.3)",
    "--tw-backdrop-blur": "blur(8px)",
    "backdropFilter": "var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)",
    "&:active": {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(108 112 97 / var(--tw-bg-opacity))"
    }
  }, {
    "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke",
    "transitionDuration": "250ms",
    "transitionTimingFunction": "ease-in-out"
  }]}>
      {children}
    </_StyledButton>;
}
var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  displayName: "deep-dive-gallery-cursor-button___StyledButton",
  componentId: "sc-1spcwhd-0"
})(["", ""], p => p.$_css);